module.exports = __webpack_public_path__ + "img/1M.1.723bea72.jpg";